<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark color="primary">
        <v-btn fab x-small color="white" depressed @click="onClose()">
          <v-icon class="primary--text">close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text pl-2">タスク管理</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-row class="ma-0 pa-0" align="center" justify="end">
          <v-col cols="1" class="py-0" align="center">
            <v-btn icon small class="ma-0" depressed @click="back">
              <v-icon>mdi-arrow-left-drop-circle-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <v-btn v-for="i in 13" small icon :key="i" class="ma-0" depressed color="transparent" style="height: 24px; width: 24px;" @click="gotoMonth(i)">
              <v-avatar v-if="myMonth != i" size="20" tile class="white--text caption" style="border: 1px solid #FFFFFF;">{{ i }}</v-avatar>
              <v-avatar v-else size="20" color="white" tile class="primary--text caption">{{ i }}</v-avatar>
            </v-btn>
          </v-col>
          <v-col cols="1" class="py-0" align="center">
            <v-btn icon small class="ma-0" depressed @click="forward">
              <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
            </v-btn>
          </v-col>
          <v-btn color="white" class="elevation-0 mx-1" x-small fab @click="onFileExport()"><v-icon color="primary">mdi-upload</v-icon></v-btn>
          <input @change="onFileImport" type="file" name="file" accept="text/csv" ref="import">
          <v-btn color="white" class="elevation-0" x-small fab @click.stop="importDialog = true"><v-icon color="primary">mdi-download</v-icon></v-btn>
        </v-row>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <v-card-text class="pa-0">
          <v-row class="ma-0 pa-0" align="center" justify="center">
            <v-col cols="6" class="pa-0" align="center">
              <v-row class="ma-0 pa-0" align="center" justify="center">
                <v-col cols="12">
                  <v-toolbar flat height="40">
                    <v-toolbar-title class="text-left">雛形</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="primary" class="elevation-0" small rounded @click.stop="onChangeCategory()"><span class="font-weight-bold">{{ menuSort == 'category' ? '時間' : '種別' }}</span></v-btn>
                    <v-btn outlined color="error" class="elevation-0 mx-2" small rounded @click="removeDialog = true, removeAll = true, removeType = 'Template'">削除</v-btn>
                  </v-toolbar>
                </v-col>
                <v-col cols="12" class="py-0 not-select">
                  <v-sheet class='overflow-y-auto pa-0 ma-0' :style="contentsHeight">
                    <template v-for="description in descriptions">
                      <v-row v-if="menuSort == 'category'" class="ma-0 pa-0" align="center" justify="center" :key="description.key">
                        <v-col cols="12" class="pa-0">
                          <v-toolbar flat :color="description.color" dark height="28">
                            <v-toolbar-title class="text-left">
                              <span>{{ description.name }}</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon small @click.stop="onAdd(menuSort, description.key)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                          </v-toolbar>
                        </v-col>
                        <v-col v-if="!prohibit" cols="12" class="pa-0">
                          <v-list dense v-if="description.value">
                            <template v-for="item in taskTemplates">
                              <v-row v-if="item.category == description.key && myMonth == item.month || item.category == description.key && item.month == 0" class="ma-0 pa-0" style="cursor: pointer;" align="center" justify="center" @click.stop="onEditTemplate(item)" :key="item.key">
                                <v-col cols="11" class="pa-0">
                                  <v-row class="ma-0 pa-0" align="center" justify="center">
                                    <v-col cols="1" class="pa-0" align="center">
                                      <p :style="getTaskTemplateWidth(item)" class="task-action">{{ getActionName(item) }}</p>
                                    </v-col>
                                    <v-col cols="6" class="py-0" align="start">
                                      <p :style="getTaskTemplateWidth(item)" class="task">{{ item.title }}</p>
                                    </v-col>
                                    <v-col cols="2" class="pa-0" align="start">
                                      <p class="caption">{{ item.description }}</p>
                                    </v-col>
                                    <v-col cols="1" class="pa-0" align="end">
                                      <v-tooltip v-if="item.description" bottom color="transparent">
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on" color="primary" size="20">mdi-pencil-box</v-icon>
                                        </template>
                                        <v-card class="pa-0" width="200">
                                          <v-card-text class="pa-1 caption">
                                            <span>{{ item.description }}</span>
                                          </v-card-text>
                                        </v-card>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" class="pa-0" align="center">
                                      {{ $MONTHS13_TABLE[item.month].name }}
                                      {{ $WEEK_ZONE_TABLE[item.week - 1].name }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="1" class="pa-0" align="center">
                                  <v-btn outlined style="height:16px; border-radius:8px; margin:0;padding:0; display:block;" color="error" class="elevation-0 ma-0 pa-0" x-small rounded @click.stop="removeDialog = true, removeAll = false, removeType = 'Template', templateItem = item">削除</v-btn>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-for="x in 4">
                      <v-row v-if="menuSort == 'time'" class="ma-0 pa-0" align="center" justify="center" :key="x + 'time'">
                        <v-col cols="12" class="pa-0">
                          <v-toolbar flat height="28" color="grey">
                            <v-row class="ma-0">
                              <v-col cols="2" class="pa-0 white--text subheading">
                                <span class="title">{{ $WEEK_ZONE_TABLE[x - 1].name }}</span>
                              </v-col>
                              <v-col cols="10" class="pa-0 text-right white--text subheading">
                                <span class="title">{{ getDayOfWeekZone(x) }}</span>
                              </v-col>
                            </v-row>
                            <v-spacer></v-spacer>
                            <v-btn icon small dark @click.stop="onAdd(menuSort, x)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                          </v-toolbar>
                        </v-col>
                        <v-col v-if="!prohibit" cols="12" class="pa-0">
                          <v-list dense :key="x + 'templates'">
                            <template v-for="item in taskTemplates">
                              <v-row v-if="checkTemplateDayAndZone(x, item)" class="ma-0 pa-0" style="cursor: pointer;" align="center" justify="center" @click.stop="onEditTemplate(item)" :key="item.key">
                                <v-col cols="11" class="pa-0">
                                  <v-row class="ma-0 pa-0" align="center" justify="center">
                                    <v-col cols="1" class="pa-0" align="center">
                                      <p :style="getTaskTemplateWidth(item)" class="task-action">{{ getActionName(item) }}</p>
                                    </v-col>
                                    <v-col cols="6" class="py-0" align="start">
                                      <p :style="getTaskTemplateWidth(item)" class="task">{{ item.title }}</p>
                                    </v-col>
                                    <v-col cols="2" class="pa-0" align="center">
                                      <p class="caption">{{ item.description }}</p>
                                    </v-col>
                                    <v-col cols="1" class="pa-0" align="end">
                                      <v-tooltip v-if="item.description" bottom color="transparent">
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on" color="primary" size="20">mdi-pencil-box</v-icon>
                                        </template>
                                        <v-card class="pa-0" width="200">
                                          <v-card-text class="pa-1 caption">
                                            <span>{{ item.description }}</span>
                                          </v-card-text>
                                        </v-card>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" class="pa-0" align="center">
                                      {{ $MONTHS13_TABLE[item.month].name }}
                                      {{ $WEEK_ZONE_TABLE[item.week - 1].name }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="1" class="pa-0" align="center">
                                  <v-btn outlined style="height:16px; border-radius:8px; margin:0;padding:0; display:block;" color="error" class="elevation-0 ma-0 pa-0" x-small rounded @click.stop="removeDialog = true, removeAll = false, removeType = 'Template', templateItem = item">削除</v-btn>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="6" class="pa-0 not-select">
              <v-row class="ma-0 pa-0" align="center" justify="center">
                <v-col cols="12">
                  <v-toolbar flat height="40">
                    <v-toolbar-title class="text-left subheading">
                      <span>{{ '（' + myMonth + '）月' }}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-select
                      prepend-icon="location_city"
                      :items='tempGroups'
                      label='教室'
                      v-model='tempGroup'
                      item-text="name"
                      item-value="key"
                      hideDetails
                    ></v-select>
                    <v-btn outlined color="primary" class="elevation-0 mx-1" small rounded @click="onChangeTaskCategory()"><span class="font-weight-bold">{{ menuTaskSort == 'category' ? '時間' : '種別' }}</span></v-btn>
                    <v-btn outlined color="error" class="elevation-0 mx-1" small rounded @click="removeDialog = true, removeAll = true, removeType = 'Tasks'">削除</v-btn>
                  </v-toolbar>
                </v-col>
              </v-row>
              <v-col cols="12" class="py-0">
                <v-sheet class='overflow-y-auto' :style="contentsHeight">
                  <template v-for="description in descriptions">
                    <v-row v-if="menuTaskSort == 'category'" class="ma-0 pa-0" align="center" justify="center" :key="description.key">
                      <v-col cols="12" class="pa-0">
                        <v-toolbar flat :color="description.color" dark height="28">
                          <v-toolbar-title>
                            <span>{{ description.name }}</span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </v-col>
                      <v-col v-if="!prohibit" cols="12" class="pa-0">
                        <v-list dense v-if="description.value">
                          <v-row v-for="item in getTaskByCategory(description.key)" class="ma-0 pa-0" align="center" justify="center" style="cursor: pointer;" @click.stop="onEditTask(item)" :key="item.key">
                            <v-col cols="11" class="pa-0">
                              <v-row class="ma-0 pa-0" align="center" justify="center">
                                <v-col cols="4" class="pa-0">
                                  <v-row class="ma-0" align="center" justify="center" :key="item.key">
                                    <v-col cols="12" class="pa-0" align="center">
                                      <v-row align="center" justify="center" class="ma-0 pa-0">
                                        <v-col cols="1" class="pa-0" align="center">
                                          <v-icon v-if="item.tag" :color="getTagColor(item)" small>mdi-tag</v-icon>
                                        </v-col>
                                        <v-col cols="3" class="pa-0 px-1" align="center">
                                          <p :style="getTaskColor(item)" class="task-action-tiny text-center">{{ getActionName(item) }}</p>
                                        </v-col>
                                        <v-col cols="8" class="pa-0 pr-1">
                                          <p :style="getTaskColor(item)" class="task-title-tiny text-left">{{ item.title }}</p>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="2" class="pa-0 px-1" align="center">
                                  <template-group-avatar :item="item" :size="16" :height="16"></template-group-avatar>
                                </v-col>
                                <v-col cols="2" class="pa-0" align="center">
                                  <p class="task-status pa-0 text-center" :style="getTaskTemplateWidth(item)">
                                    <span><v-icon size="12" :color="getCategoryColor(item)">{{ item.status ? $TASK_STATUS[item.status - 1].icon : $TASK_STATUS[0].icon }}</v-icon>
                                      {{ item.status ? $TASK_STATUS[item.status - 1].name : $TASK_STATUS[0].name }}</span>
                                  </p>
                                </v-col>
                                <v-col cols="2" class="pa-0" align="center">
                                  <p class="task-date text-center" :style="getTaskTemplateWidth(item)">{{ getDate(item.startDate) }}</p>
                                </v-col>
                                <v-col cols="2" class="pa-0" align="center">
                                  <p class="task-date  text-center" :style="getTaskTemplateWidth(item)">
                                    <span>{{ getDate(item.endDate) }}</span>
                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="1" class="pa-0" align="center">
                              <v-btn outlined style="height:16px; border-radius:8px; margin:0;padding:0; display:block;" color="error" class="elevation-0 ma-0 pa-0" x-small rounded @click.stop="removeDialog = true, removeAll = false, removeType = 'Tasks', editItem = item">削除</v-btn>
                            </v-col>
                          </v-row>
                        </v-list>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-for="x in 4">
                    <v-row v-if="menuTaskSort == 'time'" class="ma-0 pa-0" align="center" justify="center" :key="x + 'task'">
                      <v-col cols="12" class="pa-0">
                        <v-toolbar flat height="28" color="grey">
                          <v-row class="ma-0">
                            <v-col cols="2" class="pa-0 white--text subheading">
                              <span class="title">{{ $WEEK_ZONE_TABLE[x - 1].name }}</span>
                            </v-col>
                            <v-col cols="10" class="pa-0 text-right white--text subheading">
                              <span class="title">{{ getDayOfWeekZone(x) }}</span>
                            </v-col>
                          </v-row>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </v-col>
                      <v-col v-if="!prohibit" cols="12" class="pa-0">
                        <v-list dense :key="x + 'task'">
                          <v-row v-for="item in getTaskByTime(x)" class="ma-0 pa-0" style="cursor: pointer;" align="center" justify="center" @click.stop="onEditTask(item)" :key="item.key">
                            <v-col cols="11" class="pa-0">
                              <v-row class="ma-0 pa-0" align="center" justify="center">
                                <v-col cols="4" class="pa-0">
                                  <v-row class="ma-0" align="center" justify="center" :key="item.key">
                                    <v-col cols="12" class="pa-0" align="center">
                                      <v-row align="center" justify="center" class="ma-0 pa-0">
                                        <v-col cols="1" class="pa-0" align="center">
                                          <v-icon v-if="item.tag" :color="getTagColor(item)" small>mdi-tag</v-icon>
                                        </v-col>
                                        <v-col cols="3" class="pa-0 px-1" align="center">
                                          <p :style="getTaskColor(item)" class="task-action-tiny text-center">{{ getActionName(item) }}</p>
                                        </v-col>
                                        <v-col cols="8" class="pa-0 pr-1">
                                          <p :style="getTaskColor(item)" class="task-title-tiny text-left">{{ item.title }}</p>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col cols="2" class="pa-0 px-1" align="center">
                                  <template-group-avatar :item="item" :size="16" :height="16"></template-group-avatar>
                                </v-col>
                                <v-col cols="2" class="pa-0" align="center">
                                  <p class="task-status pa-0 text-center" :style="getTaskTemplateWidth(item)">
                                    <span><v-icon size="12" :color="getCategoryColor(item)">{{ item.status ? $TASK_STATUS[item.status - 1].icon : $TASK_STATUS[0].icon }}</v-icon>
                                      {{ item.status ? $TASK_STATUS[item.status - 1].name : $TASK_STATUS[0].name }}</span>
                                  </p>
                                </v-col>
                                <v-col cols="2" class="pa-0" align="center">
                                  <p class="task-date text-center" :style="getTaskTemplateWidth(item)">{{ getDate(item.startDate) }}</p>
                                </v-col>
                                <v-col cols="2" class="pa-0" align="center">
                                  <p class="task-date  text-center" :style="getTaskTemplateWidth(item)">
                                    <span>{{ getDate(item.endDate) }}</span>
                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="1" class="pa-0" align="center">
                              <v-btn outlined style="height:16px; border-radius:8px; margin:0;padding:0; display:block;" color="error" class="elevation-0 ma-0 pa-0" x-small rounded @click.stop="removeDialog = true, removeAll = false, removeType = 'Tasks', editItem = item">削除</v-btn>
                            </v-col>
                          </v-row>
                        </v-list>
                      </v-col>
                    </v-row>
                  </template>
                </v-sheet>
              </v-col>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div>
      <v-dialog v-model="mapsDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-google-maps
          v-if="mapsDialog"
          @dismissed="onDismissed"
          :dialog='mapsDialog'
          :location="myItem.location"
          :scopes="scopes"
          :scope="scope"
          :local="myItem.local"
        >
        </app-google-maps>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='editDialog'
          persistent
          :max-width="'400px'">
          <app-task-edit
            v-if="editDialog"
            @dismissed="onDismissed"
            :item="editItem"
            :dialog='editDialog'
            :task="task"
          >
          </app-task-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        :title="removeType == 'Tasks' ? 'タスク' : '雛形'"
        :message="removeAll ? '全てのデータを削除します。よろしいですか?' : '削除します。よろしいですか?'"
        :dialog='removeDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onFileSelect"
        :title="'インポート'"
        :message="'現在のテンプレートおよびタスクデータは削除されます。よろしいですか？'"
        :dialog='importDialog'
        :cancel='true'>
      </app-basic-dialog>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import * as Papa from 'papaparse'
import * as async from 'async'
import GoogleMapsDialog from '../../components/google/GoogleMapsDialog.vue'
import TaskEditDialog from './TaskEditDialog.vue'
import TemplateGroupAvatar from '../common/TemplateGroupAvatar.vue'
Vue.component('app-google-maps', GoogleMapsDialog)
Vue.component('app-task-edit', TaskEditDialog)
Vue.component('template-group-avatar', TemplateGroupAvatar)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scheduleTasks: 'scheduleTasks/events',
      templateTasks: 'templateTasks/templates',
      tags: 'tags/tags',
      windowSize: 'shared/windowSize'
    }),
    form () {
      return {
        category: this.templateItem.category,
        title: this.templateItem.title,
        startDate: this.myItem.startDate
      }
    },
    filtereTemplates () {
      var temp = []
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 64) + 'px;'
    }
  },
  props: [ 'item', 'edit', 'dialog', 'group', 'tempGroups', 'year', 'month', 'events', 'tasks', 'taskTemplates' ],
  watch: {
    templateTasks () {
      this.createTypes()
    }
  },
  data () {
    return {
      prohibit: true,
      importDialog: false,
      startDate: false,
      startTime: false,
      myItem: null,
      templateItem: null,
      editItem: null,
      editDialog: false,
      eventTemplate: null,
      mapsDialog: false,
      removeDialog: false,
      removeType: null,
      removeAll: false,
      loading: false,
      formHasErrors: false,
      types: [],
      type: null,
      charges: [],
      scopes: [],
      scope: [],
      comment: null,
      school: null,
      myMonth: null,
      task: null,
      tempKeys: {},
      tempGroup: null,
      rules: {
        required: value => !!value || '必須',
        diffDate: value => {
          var ds = new Date(this.myItem.startDate)
          var de = new Date(this.myItem.endDate)
          return ds.getTime() <= de.getTime() || '日付が無効です'
        }
      },
      descriptions: [],
      timeDescriptions: [],
      menuItems: [
        { title: '種別順', value: 'category' },
        { title: '時間順', value: 'time' }
      ],
      menuSort: 'time',
      menuTaskSort: 'category'
    }
  },
  created () {
    this.tempGroup = JSON.parse(JSON.stringify(this.group))
    Vue.prototype.$MONTHS13_FROM4_TABLE = [
      { name: '（4）月', value: 4 },
      { name: '（5）月', value: 5 },
      { name: '（6）月', value: 6 },
      { name: '（7）月', value: 7 },
      { name: '（8）月', value: 8 },
      { name: '（9）月', value: 9 },
      { name: '（10）月', value: 10 },
      { name: '（11）月', value: 11 },
      { name: '（12）月', value: 12 },
      { name: '（13）月', value: 13 },
      { name: '（1）月', value: 1 },
      { name: '（2）月', value: 2 },
      { name: '（3）月', value: 3 }
    ]
    this.myMonth = JSON.parse(JSON.stringify(this.month))
    this.templateItem = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
    var index = this.templateTasks.findIndex(event => event.key === this.item.template)
    if (index !== -1) {
      this.templateItem = JSON.parse(JSON.stringify(this.templateTasks[index]))
    }
    this.myItem = JSON.parse(JSON.stringify(this.item))
    this.descriptions = JSON.parse(JSON.stringify(this.$DESCRIPTIONS_ITEMS))
    this.timeDescriptions = JSON.parse(JSON.stringify(this.$WEEK_ZONE_TABLE))
    this.timeDescriptions.unshift({ name: '毎月', value: 0 })
    this.createTypes()
    this.createScopes()
    this.wait()
  },
  mounted () {
  },
  methods: {
    async wait () {
      this.prohibit = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(800).then(() => {
        this.prohibit = false
      })
    },
    createScopes () {
      this.scopes = []
      var keys = Object.keys(this.data.schools)
      for (var i in keys) {
        if (this.data.schools[keys[i]]) {
          var index = this.schools.findIndex(school => school.key === keys[i])
          if (index !== -1) {
            this.school = this.schools[index]
          }
          for (var x in this.groups) {
            if (this.groups[x].schools[keys[i]]) {
              this.scopes.push({
                type: 'group',
                name: this.groups[x].name,
                key: this.groups[x].key,
                item: this.groups[x]
              })
            }
          }
        }
      }
      if (this.group !== '*') {
        this.scope.push(this.group)
        this.myItem.local = true
      }
    },
    createTypes () {
      this.types = {}
      for (var i in this.templateTasks) {
        if (this.types[this.templateTasks[i].category] === undefined) {
          this.types[this.templateTasks[i].category] = []
          this.types[this.templateTasks[i].category].push(this.templateTasks[i].title)
        } else {
          this.types[this.templateTasks[i].category].push(this.templateTasks[i].title)
        }
      }
    },
    checkTemplateDay (x, item) {
      return x === item.month
    },
    checkTemplateDayAndZone (x, item) {
      if (item.month === 0) {
        return x === item.week
      }
      return item.month === this.myMonth && x === item.week
    },
    getDayOfWeekZone (zone) {
      var dd = ((zone - 1) * 7) + 1
      moment.tz.setDefault('Asia/Tokyo')
      var day = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).day()
      // day = day === 6 ? -1 : day
      if (day === 0) {
        day = 7
      } else if (day === 1) {
        day = 8
      }
      var start = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((this.myMonth - 1) * 28) + (dd - 1), 'd').format('MM/DD')
      var end = moment(String(parseInt(this.year) + '-' + '04' + '-' + '01')).add(1 - day + ((this.myMonth - 1) * 28) + (dd - 1) + 6, 'd').format('MM/DD')
      return start + ' - ' + end
    },
    getActionName (item) {
      var index = this.$ACTION_TABLE.findIndex(a => a.key === item.action)
      if (index !== -1) {
        return this.$ACTION_TABLE[index].name
      }
      return 'N/A'
    },
    getTaskByCategory (category) {
      var tasks = []
      for (var d in this.tasks[this.myMonth - 1]) {
        var temp = this.tasks[this.myMonth - 1][d]
        for (var i in temp) {
          if (temp[i].category === category) {
            if (this.tempGroup === '*') {
              tasks.push(temp[i])
            } else if (temp[i].groups[this.tempGroup]) {
              tasks.push(temp[i])
            }
          }
        }
      }
      return tasks
    },
    getTaskByTime (x) {
      var tasks = []
      var temp = this.tasks[this.myMonth - 1]
      for (var i = 0; i < 7; i++) {
        if (temp[((x - 1) * 7) + i].length !== 0) {
          for (var y in temp[((x - 1) * 7) + i]) {
            if (this.tempGroup === '*') {
              tasks.push(temp[((x - 1) * 7) + i][y])
            } else if (temp[((x - 1) * 7) + i][y].groups[this.tempGroup]) {
              tasks.push(temp[((x - 1) * 7) + i][y])
            }
          }
        }
      }
      return tasks
    },
    getTagColor (item) {
      if (item.tag) {
        var index = this.tags.findIndex(t => t.key === item.tag)
        if (index !== -1) {
          return this.tags[index].color
        }
      }
      return 'grey'
    },
    getTaskColor (item) {
      const bg = 'background-color: ' + this.getDescriptionColor(item, this.$COLOR_LIGHT) + '; '
      const border = 'border: 1px solid ' + this.getDescriptionColor(item, this.$COLOR_DEFAULT) + '; '
      const font = 'color: ' + this.getDescriptionColor(item, this.$COLOR_DARK) + '; '
      return bg + border + font
    },
    getTaskWidth (item) {
      var s = ''
      s += ' font-size:12px; color: #FFFFFF;'
      s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      return s
    },
    getTaskTemplateWidth (item) {
      var s = ''
      s += ' font-size:12px; color: ' + this.getDescriptionColor(item) + ';'
      s += ' background-color: #FFFFFF; border: 1px solid ' + this.getDescriptionColor(item) + ';'
      return s
    },
    getCharge (item) {
      var index = this.users.findIndex(user => user.key === item.charge)
      if (index !== -1) {
        return JSON.parse(JSON.stringify(this.users[index].sei))
      }
      return ' '
    },
    getAvatar (item) {
      var url = null
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].avatar) {
            return this.groups[index].avatar.thumbnail
          } else {
            break
          }
        }
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            name = this.groups[index].name.slice(0, 1)
          } else {
            break
          }
        }
      }
      return name
    },
    getGroupColor (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            return this.groups[index].color ? this.groups[index].color : 'primary'
          }
        }
      }
      return 'primary'
    },
    getDate (date) {
      return date.slice(5).replace('-', '/')
    },
    onMenu (item) {
      this.menuSort = item.value
    },
    onTaskMenu (item) {
      this.menuTaskSort = item.value
    },
    onChangeCategory () {
      this.menuSort = this.menuSort === 'category' ? 'time' : 'category'
    },
    onChangeTaskCategory () {
      this.menuTaskSort = this.menuTaskSort === 'category' ? 'time' : 'category'
    },
    onStartDate () {
      this.$refs.startDateMenu.save(this.myItem.startDate)
      if (this.myItem.endDate === null) {
        this.myItem.endDate = this.myItem.startDate
        this.$refs.endDateMenu.save(this.myItem.endDate)
      }
    },
    onAllDay () {
      this.myItem.allDayEvent = !this.myItem.allDayEvent
      if (this.myItem.allDayEvent) {
        this.myItem.startTime = null
        this.myItem.endTime = null
      }
    },
    onPrivate () {
      this.myItem.local = !this.myItem.local
      if (!this.myItem.local) {
        this.scope = []
      }
    },
    onSelect (item) {
      this.templateItem = item
      this.myItem = JSON.parse(JSON.stringify(this.$store.getters['scheduleTasks/initial']))
      var date = this.getTopOfDays(this.year, item.month, item.week).str
      var start = moment(date, 'YYYY-MM-DD')
      this.myItem.startDate = start.format('YYYY-MM-DD')
      this.myItem.start = {
        date: start.format('YYYY-MM-DD'),
        yyyy: parseInt(start.format('YYYY')),
        mm: parseInt(start.format('MM')),
        dd: parseInt(start.format('DD'))
      }
      this.myItem.template = item.key
      this.myItem.duration = item.period
    },
    onSelectTask (item) {
      this.myItem = JSON.parse(JSON.stringify(item))
      this.templateItem = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
      var index = this.templateTasks.findIndex(event => event.key === this.myItem.template)
      if (index !== -1) {
        this.templateItem = JSON.parse(JSON.stringify(this.templateTasks[index]))
      }
    },
    onMapSearch () {
      this.mapsDialog = true
    },
    onAdd (sort, item) {
      this.editItem = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
      if (sort === 'category') {
        this.editItem.category = item
        this.editItem.month = 0
        this.editItem.week = 1
      } else {
        this.editItem.month = 0
        this.editItem.week = item
      }
      this.task = 'template'
      this.editDialog = true
    },
    onEditTemplate (item) {
      this.editItem = JSON.parse(JSON.stringify(item))
      this.task = 'template'
      this.editDialog = true
    },
    onEditTask (item) {
      this.editItem = JSON.parse(JSON.stringify(item))
      this.task = 'task'
      this.editDialog = true
    },
    onRemove () {
      var vm = this
      this.loading = true
      this.$nextTick(function () {
        this.prohibit = true
        var path = this.removeType === 'Template' ? 'templateTasks/delete' : 'scheduleTasks/delete'
        if (this.removeAll) {
          if (this.removeType === 'Template') {
            this.removeAllSub(JSON.parse(JSON.stringify(vm.scheduleTasks)), 'scheduleTasks/delete', false).then(() => {
              this.removeAllSub(JSON.parse(JSON.stringify(vm.templateTasks)), 'templateTasks/delete', false).then(() => {
                vm.prohibit = false
                vm.loading = false
              })
            })
          } else {
            this.removeAllSub(JSON.parse(JSON.stringify(vm.scheduleTasks)), 'scheduleTasks/delete', true).then(() => {
              vm.prohibit = false
              vm.loading = false
            })
          }
        } else {
          var payload = vm.removeType === 'Template' ? vm.templateItem.key : vm.editItem.key
          vm.$store.dispatch(path, payload).then(() => {
            if (this.removeType === 'Template') {
              var temp = vm.scheduleTasks.filter(function (item, index) {
                return item.template === payload
              })
              this.removeAllSub(JSON.parse(JSON.stringify(temp)), 'scheduleTasks/delete', false).then(() => {
                vm.loading = false
                vm.prohibit = false
              })
            } else {
              vm.loading = false
              vm.prohibit = false
            }
          })
        }
      })
    },
    gotoMonth (i) {
      this.myMonth = i
    },
    back () {
      this.$emit('back')
      this.myMonth -= 1
      if (this.myMonth <= 0) {
        this.myMonth = 13
      }
    },
    forward () {
      this.myMonth += 1
      if (this.myMonth > 13) {
        this.myMonth = 1
      }
    },
    onFileSelect: function (value) {
      this.importDialog = false
      if (value) {
        this.$nextTick(function () {
          this.$refs.import.click()
        })
      }
    },
    checkGroup (item) {
      if (this.tempGroup === '*') {
        return true
      }
      if (typeof item.groups[this.tempGroup] === 'undefined') {
        return false
      }
      return item.groups[this.tempGroup]
    },
    removeAllSub (items, path, check) {
      var vm = this
      return new Promise((resolve) => {
        async.eachSeries(items, function (item, cb) {
          var payload = item.key
          if (item.schools[vm.school.key]) {
            if (!check || (check && vm.checkGroup(item))) {
              vm.$store.dispatch(path, payload).then(() => {
                cb()
              })
            } else {
              cb()
            }
          }
        }, function (error) {
          if (error) {
            // console.log(error)
          }
          resolve()
        })
      })
    },
    removeAllDate () {
      var vm = this
      return new Promise((resolve) => {
        this.removeAllSub(JSON.parse(JSON.stringify(vm.scheduleTasks)), 'scheduleTasks/delete', true).then(() => {
          this.removeAllSub(JSON.parse(JSON.stringify(vm.templateTasks)), 'templateTasks/delete', true).then(() => {
            resolve()
          })
        })
      })
    },
    onFileImport (e) {
      var vm = this
      this.tempKeys = {}
      vm.file = null
      e.preventDefault()
      let files = e.target.files
      if (files.length === 0) {
        return
      }
      this.file = files[0]
      var reader = new FileReader()
      reader.onerror = function () {
        // console.log('error')
      }
      this.loading = true
      this.$nextTick(function () {
        const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
        pause(50).then(() => {
          this.prohibit = true
          this.removeAllDate().then(() => {
            reader.onload = function () {
              Papa.parse(files[0], {
                encoding: 'UTF8',
                header: true,
                complete: function (results) {
                  async.eachSeries(results.data, function (item, cb) {
                    if (item.type === 'template') {
                      vm.storeEvent(item).then(() => {
                        cb()
                      })
                    } else {
                      cb()
                    }
                  }, function (error) {
                    if (error) {
                      // console.log(error)
                    }
                    vm.prohibit = false
                    vm.loading = false
                    // })
                  })
                },
                error () {
                  vm.prohibit = false
                  vm.loading = false
                }
              })
            }
            reader.readAsArrayBuffer(this.file)
          })
        })
      })
    },
    storeEvent (item) {
      return new Promise((resolve) => {
        var vm = this
        var payload = null
        var path = 'templateTasks/write'
        if (item.type === 'task') {
          path = 'scheduleTasks/write'
          payload = JSON.parse(JSON.stringify(this.$store.getters['scheduleTasks/initial']))
          var start = moment(item.startDate)
          moment.tz.setDefault('Asia/Tokyo')
          payload.startDate = item.startDate
          payload.start = {
            date: start.format('YYYY-MM-DD'),
            yyyy: parseInt(start.format('YYYY')),
            mm: parseInt(start.format('MM')),
            dd: parseInt(start.format('DD'))
          }
          payload.startTime = item.startTime === '' ? null : item.startTime
          var end = moment(item.endDate)
          payload.endDate = item.endDate
          payload.end = {
            date: end.format('YYYY-MM-DD'),
            yyyy: parseInt(end.format('YYYY')),
            mm: parseInt(end.format('MM')),
            dd: parseInt(end.format('DD'))
          }
          payload.endTime = item.endTime === '' ? null : item.endTime
          payload.duration = parseInt(item.duration)
          payload.template = vm.tempKeys[item.template]
          var groups = {}
          for (var i in this.group) {
            groups[this.group[i]] = true
          }
          payload.groups = groups
        } else {
          payload = JSON.parse(JSON.stringify(this.$store.getters['templateTasks/initial']))
          payload.category = parseInt(item.category)
          payload.title = item.title
          payload.action = parseInt(item.action)
          payload.description = item.description
          payload.month = parseInt(item.month)
          payload.week = parseInt(item.week)
          payload.period = parseInt(item.period)
        }
        payload.schools[this.school.key] = true
        payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
        vm.$store.dispatch(path, JSON.parse(JSON.stringify(payload))).then((resp) => {
          if (typeof resp !== 'undefined' && resp.type === 'template') {
            vm.tempKeys[item.key] = resp.key
          }
          resolve()
        })
      })
    },
    onFileExport () {
      var temp = []
      var name = 'export-task'

      const config = {
        delimiter: ',',
        header: true,
        newline: '\n'
      }

      for (var i in this.taskTemplates) {
        var v = JSON.parse(JSON.stringify(this.taskTemplates[i]))
        temp.push({
          type: 'template',
          key: v.key,
          category: v.category,
          title: v.title,
          action: v.action,
          description: v.description,
          month: v.month,
          week: v.week,
          period: v.period,
          template: null,
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          duration: null,
          status: null,
          target: null,
          result: null
        })
      }
      for (i in this.scheduleTasks) {
        v = JSON.parse(JSON.stringify(this.scheduleTasks[i]))
        temp.push({
          type: 'task',
          template: v.template,
          startDate: v.startDate,
          startTime: v.startTime,
          endDate: v.endDate,
          endTime: v.endTime,
          duration: v.duration
        })
      }
      const delimiterString = Papa.unparse(temp, config)
      const blobUrl = new Blob([delimiterString], { type: 'text/csv' })
      const blob = blobUrl
      const aTag = document.createElement('a')

      aTag.download = this.year + '-' + name + '.csv'

      if (window.navigator.msSaveBlob) {
        // for IE
        window.navigator.msSaveBlob(blob, aTag.download)
      } else if (window.URL && window.URL.createObjectURL) {
        // for Firefox
        aTag.href = window.URL.createObjectURL(blob)
        document.body.appendChild(aTag)
        aTag.click()
        document.body.removeChild(aTag)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        // for Chrome
        aTag.href = (window.URL || window.webkitURL).createObjectURL(blob)
        aTag.click()
      } else {
        // for Safari
        window.open(
          `data:type/csv;base64,${window.Base64.encode(this.state.content)}`,
          '_blank'
        )
      }
    },
    onClose () {
      this.$emit('dismissed')
    },
    onDismissed: function (value) {
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          this.onRemove()
        }
        return
      }
      if (value) {
        this.myItem.location = value.name
      }
      this.editDialog = false
      this.mapsDialog = false
    }
  }
}
</script>

<style scoped>

.v-row.select {
  cursor: pointer !important;
}

.not-select {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

p.task {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  line-height: 16px !important;
}

p.task-action {
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px !important;
  border-radius: 0px;
  padding: 0px;
  margin: 0px;
}

span.description {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  padding: 0px;
  margin: 0px;
}

p.group {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 8px;
  line-height: 16px !important;
  text-align: center;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

p.charge {
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px;
  border-radius: 8px;
  padding: 0px;
  margin: 0px;
}

p.task-status {
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  border-radius: 0px;
  line-height: 16px;
}

p.task-date {
  font-size: 12px !important;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  padding: 0px;
  margin: 2px;
}

p.task-action-tiny {
  font-size: 12px !important;
  line-height: 16px !important;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  padding: 0px !important;
  margin: 0px !important;
}

p.task-title-tiny {
  font-size: 12px !important;
  line-height: 16px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 0px;
  padding: 0px !important;
  padding-left: 6px !important;
  margin: 0px !important;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
  padding-left: 6px;
  margin: 2px;
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

span {
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

input[type="file"] {
  display: none;
}

.b-R {
  border-right: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L {
  border-left: 1px solid white !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T {
  border-top: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B {
  border-bottom: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-R-GREY {
  border-right: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L-GREY {
  border-left: 1px solid grey !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T-GREY {
  border-top: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
/* ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
} */
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}
</style>
